export type FormVersionParentPath = {
  formId: string;
  versionId: string;
};

export function parseFormVersionParentPath(parentPath: string): FormVersionParentPath | null {
  const parts = parentPath.split('/').filter(Boolean);
  if (parts.length === 4 && parts[0] === 'forms' && parts[2] === 'formVersions') {
    return { formId: parts[1], versionId: parts[3] };
  }
  return null;
}
